<template>
  <div class="commentArea">
    <p v-for="item of displayComments" :key="item.id" :class="item.class">
      <icon-image
        :iconUrl="item.icon_url + '/128'"
        size="24"
        class="icon_img"
      />
      <span v-if="item.shouldDisplayName" @click="clickName" class="name">{{
        item.name
      }}</span>
      <span>{{ item.content }}</span>
    </p>
  </div>
</template>

<script>
import IconImage from '@/components/IconImage.vue'
export default {
  name: 'CommentArea',
  components: {
    IconImage,
  },
  props: {
    comments: Array,
  },
  data: function () {
    return {
      displayComments: [],
    }
  },
  computed: {
    shouldScroll() {
      return (
        this.$el.scrollHeight === this.$el.scrollTop + this.$el.clientHeight
      )
    },
  },
  watch: {
    comments: function () {
      this.scrollToBottom()
    },
  },
  methods: {
    clickName() {
      this.$emit('clickName')
    },
    debounce: function (completion, interval) {
      let timer
      return () => {
        clearTimeout(timer)
        timer = setTimeout(() => {
          completion()
        }, interval)
      }
    },
    scrollToBottom: function () {
      // コメント取得時に特定条件でスクロールしたいのだが、画面遷移直後に大量にコメントが追加された際の動きが微妙なためワークアラウンドとしてデバウンスで対応している
      this.debounce(() => {
        this.displayComments = this.comments
        if (this.shouldScroll) {
          this.$el.scrollTo(0, this.$el.scrollHeight)
        }
      }, 100)()
    },
  },
}
</script>

<style scoped>
.commentArea {
  overflow: auto;
}

.commentArea p {
  border-radius: 4px;
  margin: 8px 16px;
  padding: 2px 8px;
  font-size: 1.5rem;
  width: fit-content;
}

.commentArea .comment {
  background-color: rgba(255, 255, 255, 0.9);
  color: rgb(56, 56, 56);
}

.commentArea .comment .name {
  color: #188dff;
}

.commentArea .system {
  background-color: rgba(128, 128, 128, 0.9);
  color: rgb(255, 255, 255);
}

.commentArea .gift,
.commentArea .avatarGift {
  background-color: rgba(247, 61, 89, 0.9);
  color: rgb(255, 255, 255);
}

.commentArea .soft {
  background-color: rgba(128, 128, 128, 0.9);
  color: rgb(255, 255, 255);
}

.commentArea .name {
  margin-right: 8px;
}

@media screen and (min-width: 0px) {
  .commentArea p {
    font-size: 0.7rem;
  }
}
@media screen and (min-width: 425px) {
  .commentArea p {
    font-size: 1rem;
  }
}
@media screen and (min-width: 768px) {
  .commentArea p {
    font-size: 1rem;
  }
}

.icon_img {
  margin: 0 4px 0 0;
}
</style>
